// extracted by mini-css-extract-plugin
export default {"bashArrays":"BashArrays_bashArrays__NM4eC"};